module.exports = __webpack_public_path__ + "img/img2.dafe787a.png";